import { WarningLevel } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';

import { messages } from './PriceCheckIndicator.messages';
import { PriceCheckIndicatorProps } from './PriceCheckIndicator.types';

export const getWarningLevel = (
    actualPrice?: number,
    expectedPrice?: number,
    isMultiCurrency?: boolean,
    isSalesPrice?: boolean
) => {
    if (actualPrice == null || expectedPrice == null) {
        return;
    }

    if (isMultiCurrency) {
        return WarningLevel.Black;
    }

    const diff = isSalesPrice ? expectedPrice - actualPrice : actualPrice - expectedPrice;

    if (diff / expectedPrice > 0.25) {
        return WarningLevel.Red;
    }

    if (diff / expectedPrice > 0.05) {
        return WarningLevel.Orange;
    }

    if (diff / expectedPrice > 0) {
        return WarningLevel.Yellow;
    }

    return;
};

export const getRequestNameShort = (integrationCode: domain.IntegrationCode) => {
    switch (integrationCode) {
        case domain.IntegrationCode.XeroPo:
        case domain.IntegrationCode.QBooksPo:
        case domain.IntegrationCode.NetSuitePO:
        case domain.IntegrationCode.DearPo:
            return messages.purchaseOrderShort;

        default:
            return null;
    }
};

export const getSystemName = (integrationType: PriceCheckIndicatorProps['integrationType']) => {
    switch (integrationType) {
        case domain.IntegrationType.Xero:
            return messages.xeroSystemName;

        case domain.IntegrationType.NetSuite:
            return messages.netSuiteSystemName;

        case domain.IntegrationType.QBooks:
            return messages.qBooksSystemName;

        default:
            return '';
    }
};
